(function ($) {
  'use strict';

  window.ys.lv2025 = new LaVuelta2025();

  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('lv_2025')) {
    window.ys.lv2025Contest = new LaVuelta2025.Contest();
    console.log('lv_2025');
  }

  $(document).ready(function () {
    function initializeFlickity() {
      var $carousel = $('.carousel-posts-carousel');
      var flkty;

      if (window.matchMedia('(max-width: 768px)').matches) {
        flkty = $carousel.flickity({
          wrapAround: true,
          arrowShape: {
            x0: 25,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 40,
          },
        });
      } else {
        flkty = $carousel.flickity({
          wrapAround: true,
          cellAlign: 'left',
          arrowShape: {
            x0: 25,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 40,
          },
        });
      }

      return flkty;
    }

    // Initialize Flickity on page load
    var flkty = initializeFlickity();

    // Re-initialize Flickity on window resize
    window.addEventListener('resize', function () {
      // Destroy the current instance and re-initialize
      $('.carousel-posts-carousel').flickity('destroy');
      flkty = initializeFlickity();
    });
  });
}).bind(window)(jQuery);
